import { MessageError } from "src/types/errors/errors";

export const eventsErrors: MessageError[] = [
    {
        key: 'Event is not active',
        value: 'Evento não está ativo',
    },
    {
        key: 'Event is external, cannot redeem',
        value: 'Evento externo, não pode ser reservado',
    },
    {
        key: 'Invalid number of adults and/or children',
        value: 'Número inválido de crianças e/ou adultos',
    },
    {
        key: 'Cannot redeem event in the past',
        value: 'Evento no passado não pode ser reservado',
    },
    {
        key: 'No slots at this date',
        value: 'Sem vagas nessa data',
    },
    {
        key: 'Not enough slots available',
        value: 'Sem vagas disponíveis',
    },
    {
        key: 'You already have a schedule for this event',
        value: 'Você já possui uma reserva para esse evento',
    },
    {
        key: 'Not enough points',
        value: 'Ops! Você não tem pontos suficientes. ',
    },
    {
        key: 'A problem has ocurred, please try again',
        value: 'Ocorreu um problema, tente novamente',
    },
]
